import { ofType } from "redux-observable";
import { map } from "rxjs/operators";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { actionAppsflyerUpdate, TypeActionAppsflyer, } from "../actionAppsflyer";
import { IdAppsflyerEvents } from "../IdAppsflyerEvents";
export var epicAppsflyerLevelUp = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionAppsflyer.LevelUp), map(function (action) {
        var eventName = IdAppsflyerEvents.LEVEL_X_ACHIEVED.replace(ReplacementLoca.zero_0, "" + action.playerLevel);
        var eventValue = {
            LEVEL: action.playerLevel,
        };
        return actionAppsflyerUpdate(eventName, eventValue);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/appsflyer/epics/epicAppsflyerLevelUp.ts
// module id = 1774
// module chunks = 3